if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.colorInput =
        this.form?.querySelector('input[name="properties[Fabric Color]"], input#color-property') ?? null;
      if (this.colorInput) {
        this.colorInput.addEventListener('input', () => this.handleErrorMessage());
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // When the "select a fabric color" error fires, open the colour tab, scroll to it,
      // and highlight the picker so the shopper can choose a fabric.
      revealColorPicker() {
        try {
          const picker = document.querySelector('[data-color-picker], .custom-color-picker');
          if (!picker) return;
          const panel = picker.closest('[data-variant-tab-panel], .variant-tab-panel');
          if (panel && panel.id) {
            const tabBtn = document.querySelector('[data-variant-tab-button][aria-controls="' + panel.id + '"]');
            if (tabBtn && tabBtn.getAttribute('aria-selected') !== 'true') tabBtn.click();
          }
          const scrollTarget = (panel && panel.closest('.variant-tabs')) || picker;
          requestAnimationFrame(() => {
            try { scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
            picker.style.transition = 'box-shadow .3s ease';
            picker.style.boxShadow = '0 0 0 3px rgba(2, 48, 32, 0.55)';
            setTimeout(() => { picker.style.boxShadow = ''; }, 2200);
            const firstSwatch = picker.querySelector('input[name="color"], .grid-item input, [role="radio"]');
            if (firstSwatch && firstSwatch.focus) { try { firstSwatch.focus({ preventScroll: true }); } catch (e) {} }
          });
        } catch (e) { /* non-fatal */ }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const loadingSpinner = this.querySelector('.loading__spinner');

        // Check if native Fabric Colour variant exists - if so, skip custom color validation
        // Search entire document since variant radios may be outside product-form
        const hasFabricColourVariant = document.querySelector(
          'input[type="radio"][name*="Fabric Colour"], input[type="radio"][name*="Fabric Color"]'
        );

        if (this.form?.dataset?.requiresColorSelection === 'true' && !hasFabricColourVariant) {
          const colorValue = this.colorInput?.value?.trim();
          if (!colorValue) {
            this.handleErrorMessage('Please select a fabric color before adding this product to your cart.');
            this.revealColorPicker();
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            loadingSpinner?.classList.add('hidden');
            return;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        loadingSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Item added successfully — go straight to checkout (skip the cart drawer / cart page).
            window.location.href =
              (window.routes && window.routes.checkout_url) ? window.routes.checkout_url : '/checkout';
          })
          .catch((e) => {
            console.error(e);
            this.fallbackToNativeSubmit('Something went wrong. Redirecting to cart…');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            loadingSpinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      fallbackToNativeSubmit(message) {
        this.handleErrorMessage(message);
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
        // Use native submit as a safety net for browsers that block fetch/JS
        this.form?.submit();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
